"use client";

import Logo from "./Logo";
import Notice from "./Notice";
import Button from "./Button";
import { worldPlayScreen } from "../worlds/registry";
import { AccountView } from "@/lib/types";

/** 選ばれた世界の、キャラを選んだ後の画面を出す */
export default function WorldPlayScreen({
  world,
  region,
  slug,
  account,
  onExit,
  onLogout,
}: {
  world: string;
  region: string;
  slug: string;
  account: AccountView;
  onExit: () => void;
  onLogout: () => void;
}) {
  const Screen = worldPlayScreen(world);

  if (Screen) {
    return <Screen region={region} slug={slug} account={account} onExit={onExit} onLogout={onLogout} />;
  }

  return (
    <div className="panel">
      <Logo />
      <Notice>
        <p>{world} の画面は未実装です。</p>
      </Notice>
      <div className="foot">
        <Button onClick={onExit} inline>
          戻る
        </Button>
      </div>
    </div>
  );
}
